import { useApp } from '../../state/AppContext';
import Icon from '../../lib/Icon';
import { cardPad } from '../../lib/ui';
import { notifData } from '../../lib/notifications';

export default function Notifs() {
  const { set, L } = useApp();

  const notifCenter = notifData().map((n) => ({
    ...n,
    border: n.unread ? n.iconColor : 'var(--color-border)',
    priority: n.kind === 'alert' ? L('High', 'สูง') : n.kind === 'action' ? L('Action', 'ต้องดำเนินการ') : L('Info', 'ข้อมูล'),
  }));

  return (
    <>
      <div style={{ display: 'flex', gap: 8, marginBottom: 16 }}>
        <button style={{ padding: '8px 16px', background: 'var(--color-bg-inverse)', color: '#fff', borderRadius: 'var(--radius-pill)', fontSize: 13, fontWeight: 600 }}>{L('All', 'ทั้งหมด')}</button>
        <button className="hv-ink" style={{ padding: '8px 16px', border: '1px solid var(--color-border-strong)', borderRadius: 'var(--radius-pill)', fontSize: 13, fontWeight: 600, background: 'var(--color-white)', display: 'flex', alignItems: 'center', gap: 6 }}>{L('Unread', 'ยังไม่อ่าน')} <span style={{ background: 'var(--color-error)', color: '#fff', borderRadius: 999, fontSize: 10, padding: '1px 6px', fontFamily: 'var(--font-mono)' }}>3</span></button>
        <button className="hv-ink" style={{ padding: '8px 16px', border: '1px solid var(--color-border-strong)', borderRadius: 'var(--radius-pill)', fontSize: 13, fontWeight: 600, background: 'var(--color-white)' }}>{L('High', 'สูง')}</button>
        <div style={{ flex: 1 }}></div>
        <button onClick={() => set({ unreadCount: 0 })} style={{ padding: '8px 16px', fontSize: 13, fontWeight: 600, color: 'var(--color-blue)' }}>{L('Mark All Read', 'ทำเครื่องหมายว่าอ่านแล้วทั้งหมด')}</button>
      </div>
      <div style={cardPad(0, 'hidden')}>
        {notifCenter.map((n, i) => (
          <div key={i} style={{ display: 'flex', gap: 12, padding: '14px 18px', borderBottom: '1px solid var(--color-border)', background: n.rowBg }}>
            <div style={{ width: 32, height: 32, flex: 'none', borderRadius: 999, display: 'flex', alignItems: 'center', justifyContent: 'center', color: n.iconColor, background: n.iconBg, fontSize: 16 }}><Icon name={n.icon} /></div>
            <div style={{ flex: 1 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <span style={{ fontSize: 13, fontWeight: 700 }}>{n.title}</span>
                <span style={{ fontSize: 9, fontWeight: 700, letterSpacing: '.06em', color: n.iconColor }}>{n.priority}</span>
              </div>
              <div style={{ fontSize: 12, color: 'var(--color-fg-2)' }}>{n.msg}</div>
              <div style={{ fontSize: 11, color: 'var(--color-fg-3)', marginTop: 2 }}>{n.time}</div>
            </div>
            <button style={{ fontSize: 12, fontWeight: 600, color: 'var(--color-blue)', alignSelf: 'center' }}>{L('Mark read', 'ทำเครื่องหมายว่าอ่านแล้ว')}</button>
          </div>
        ))}
      </div>
    </>
  );
}
